function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { handleImageFormat } from "./format";
import { handleImageQuality } from "./quality";
import { handleImageResize, handleThumbnailResize } from "./resize";
import { isSupportedDomain, toRelativePath } from "./s3-path";
export function getProcessedUrl(src, options) {
  // undefined 和 null 都返回空字符串
  if (!src) return '';
  // 不支持处理的域名，直接返回
  if (!isSupportedDomain(src)) return src;
  var resize = options.resize,
    format = options.format,
    quality = options.quality,
    thumbnail = options.thumbnail;

  // 处理选项参数
  var final_format = handleImageFormat(format);
  var final_quality = handleImageQuality(quality, format);
  var final_resize = thumbnail ? handleThumbnailResize(resize) : handleImageResize(resize);

  // 拼接url
  var base_url = toRelativePath(src);
  var params = new URLSearchParams();
  if (final_format) params.set('format', final_format);
  if (final_quality) params.set('quality', String(final_quality));
  if (final_resize) {
    var resize_arr = [];

    // 其他参数统一处理即可
    Object.keys(final_resize).forEach(function (key) {
      var value = final_resize[key];
      if (value) {
        resize_arr.push("".concat(key, "/").concat(value));
      }
    });
    if (resize_arr.length > 0) {
      params.set('resize', resize_arr.join(','));
    }
  }
  return "".concat(base_url, "?").concat(params.toString());
}

// 根据像素密度获取srcset
var PixelRatios = [1, 1.5, 2, 2.5, 3];
export function getProcessedSrcset(src, options) {
  var srcset = [];
  PixelRatios.forEach(function (ratio) {
    var processed_url = getProcessedUrl(src, _objectSpread(_objectSpread({}, options), {}, {
      resize: _objectSpread(_objectSpread({}, options.resize), {}, {
        ratio: ratio
      })
    }));
    srcset.push("".concat(processed_url, " ").concat(ratio, "x"));
  });
  return srcset.join(', ');
}